import React from "react"
import styled from "@emotion/styled"
import CookieConsent from "react-cookie-consent"

const Link = styled.a`
  color: ${props => props.theme.shade[100]};
`

export default function Cookie(props) {
  return (
    <CookieConsent
      style={{
        background: "#3c4044",
        padding: "16px 32px",
        alignItems: "center",
        zIndex: "2",
      }}
      buttonText="Accept"
      buttonStyle={{
        background: "#ffffff",
        padding: "16px 40px",
        borderRadius: "40px",
        fontWeight: "500",
      }}
    >
      We use cookies on our website to give you the most relevant experience by
      remembering your preferences and repeat visits. By clicking “Accept”, you
      consent to the use of ALL the cookies. However you can read our{" "}
      <Link href="/legal/cookie-policy/">Cookie Policy</Link> for more
      information.
    </CookieConsent>
  )
}
